const styles = (theme) => ({
  dialog: {
    width: 470,
    backgroundColor: theme.gridBGColor,
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: 16,
  },
  deliveryBillsHeaderText: {
    color: theme.TextColor,
  },
  dialogWrapper: {},
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
  errorContainer: {
    marginBottom: 16,
  },
});

export default styles;
